import { z } from 'zod';

// ParkpliantGroup is a routing bucket from the backend catalog
// (GET /monitor/violation/parkpliant/groups). `id` is the value bound to a
// location's / block face's parkpliant_group_id; `name` is the display label.
export const ParkpliantGroupSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  parkpliant_id: z.string(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});

export const ParkpliantGroupListSchema = z.array(ParkpliantGroupSchema);

export type ParkpliantGroupType = z.infer<typeof ParkpliantGroupSchema>;
